import React, { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../components/Sidebar";
import StudentBioDataForm from "../components/biodata"; // Import the biodata form
import "../assets/css/editprofile.css"; // Import your CSS file

const isProduction = process.env.NODE_ENV === "production";
const API_BASE_URL = isProduction
  ? "https://schools.luth.gov.ng" || "https://10.0.0.57"
  : "http://localhost:3003";

const EditProfile = () => {
  const [bioData, setBioData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    axios
      .get(`${API_BASE_URL}/api/biodata/${localStorage.getItem("matricNo")}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setBioData(res.data))
      .catch(() => {});
  }, []);

  useEffect(() => {
    const fetchBioData = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const response = await axios.get(`${API_BASE_URL}/api/biodata`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setBioData(response.data); // Fill form with fetched biodata
      } catch (error) {
        console.error("No biodata found, showing empty form.");
      } finally {
        setLoading(false);
      }
    };

    fetchBioData();
  }, []);

  if (loading) return <p style={{ padding: "2rem" }}>Loading...</p>;

  return (
    <div className="dashboard" style={{ display: "flex", marginTop: "-120px" }}>
      {/* Sidebar component */}
      <Sidebar />
      <div className="main-content">
        <StudentBioDataForm initialData={bioData} isEditMode={true} />
      </div>
    </div>
  );
};

export default EditProfile;
